import { reactify } from '@zeiss/zui-react';
export const ZuiIconMedPupillography = reactify('zui-icon-med-pupillography');
